import { ReactNode } from 'react'

import { SourceType } from '@ui/__generated__/graphql'
import { AWSLambdaConfiguration } from '@ui/pages/onboarding/components/configuration/AWSLambdaConfiguration'
import { DatadogConfiguration } from '@ui/pages/onboarding/components/configuration/DatadogConfiguration'
import { FluentbitConfiguration } from '@ui/pages/onboarding/components/configuration/FluentbitConfiguration'
import { NewRelicConfiguration } from '@ui/pages/onboarding/components/configuration/NewRelicConfiguration'
import { OpenTelemetryConfiguration } from '@ui/pages/onboarding/components/configuration/OpenTelemetryConfiguration'
import { ConfigurationProps } from '@ui/pages/onboarding/components/configuration/types'
import { VercelConfiguration } from '@ui/pages/onboarding/components/configuration/VercelConfiguration'

type SourceConfig = {
  instructions: (props: ConfigurationProps) => ReactNode
}

export const sourceTypeConfigs: Omit<Record<SourceType, SourceConfig>, SourceType.CatchAll> = {
  [SourceType.Datadog]: {
    instructions: (props) => <DatadogConfiguration {...props} />,
  },
  [SourceType.NewRelic]: {
    instructions: (props) => <NewRelicConfiguration {...props} />,
  },
  [SourceType.Otel]: {
    instructions: (props) => <OpenTelemetryConfiguration {...props} />,
  },
  [SourceType.AwsLambda]: {
    instructions: (props) => <AWSLambdaConfiguration {...props} />,
  },
  [SourceType.Vercel]: {
    instructions: (props) => <VercelConfiguration {...props} />,
  },
  [SourceType.Fluentbit]: {
    instructions: (props) => <FluentbitConfiguration {...props} />,
  },
}
